export class LoginModel
{
    public Username: string = "";
    public Password: string = "";
    // public old: string = "";
    public newPassword: string = "";
    public cnfrmNewPassword: string = "";
    public OTP: string = "";
}